/**
 * Is this catalogue product a warranty plan?
 *
 * ONE KEY. `isWarrantyProduct` is attached by `withPosHelpers` in
 * api/products.js, which every product-returning path now runs — search, grid,
 * category browse, barcode, sku lookup, and both offline branches. So there is
 * exactly one spelling to read.
 *
 * This used to test two spellings (`is_warranty_product` then
 * `isWarrantyProduct`), which read as defensive and was false comfort: it
 * defended against a rename, while the failure this codebase actually has is
 * OMISSION. When the quickSearch whitelist dropped the field, neither spelling
 * was present and the second lookup bought nothing — the guard returned false
 * and a warranty went into the cart from search. Normalising at the API layer is
 * what makes one key safe; checking two keys never was.
 *
 * Deliberately NOT inferred from SKU or name. Warranty SKUs on this catalogue
 * look like WRN-19P5A15, EXCL-..., and names vary by provider; a pattern match
 * would both miss plans and catch real products.
 *
 * Absent => not a warranty. That is fail-open, and it is safe only because the
 * server refuses an unlinked warranty at commit (recordCartWarranties derives
 * warranty-ness from warranty_products, PR #183). This guard makes the refusal
 * happen at the tile instead of at payment; it is not the thing preventing a
 * mis-sale.
 */
export function isWarrantyProduct(product) {
  return product?.isWarrantyProduct === true;
}

export default isWarrantyProduct;
